import { render, staticRenderFns } from "./Advance.vue?vue&type=template&id=252928d0&scoped=true"
import script from "./Advance.vue?vue&type=script&lang=js"
export * from "./Advance.vue?vue&type=script&lang=js"
import style0 from "./Advance.vue?vue&type=style&index=0&id=252928d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252928d0",
  null
  
)

export default component.exports